import { motion } from 'framer-motion';

export const LegalPageLayout = ({ testId, title, subtitle, lastUpdated, children }) => {
  return (
    <main data-testid={testId}>
      {/* Hero */}
      <section className="pt-24 lg:pt-32 pb-12 lg:pb-16 bg-[#1F2A44]">
        <div className="container-peak">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <span className="section-tag block mb-4 lg:mb-6">Legal</span>
            <h1 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.1] mb-4 text-[#F4F1EC]">
              {title}
            </h1>
            {subtitle && (
              <p className="text-[#F4F1EC]/70 text-base lg:text-lg max-w-2xl">
                {subtitle}
              </p>
            )}
            <p className="text-[#F4F1EC]/40 text-xs uppercase tracking-[0.15em] mt-6 font-['Syne']">
              Last updated: {lastUpdated}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-14 lg:py-20 bg-[#F4F1EC]">
        <div className="container-peak">
          <div className="max-w-3xl legal-content" data-testid="legal-content">
            {children}
          </div>
        </div>
      </section>
    </main>
  );
};

export default LegalPageLayout;
